import { I18n } from 'aws-amplify';
import React from 'react';
import classNames from "classnames";

export const GrilleCard = (parentProps) => {
    const lng = I18n.get("currentlanguage");

    const getGrille = (module) => {
        if (module.grilles && module.grilles.length > 0) {
            const foundGrille = module.evaluatedGrille ? module.evaluatedGrille : module.grilles.find(g => g.language === lng);
            if (foundGrille) {
                return <li><button onClick={() => parentProps.handleGrilleSelection(module, foundGrille)} rel="noopener noreferrer" className={classNames("cdmButtonLink", {
                    "cdmButtonLinkBlue": module.draft,
                    "cdmButtonLinkGreen": module.evaluated,
                })} ><i className={classNames({
                    "fas fa-graduation-cap": !module.draft && !module.evaluatedGrille,
                    "fab fa-firstdraft": module.draft,
                    "fas fa-signature": module.evaluated,
                })}></i> {foundGrille.codeModule} - {foundGrille.name}</button></li>;
            }
            return <li style={{ color: "orange" }}><button style={{ color: "orange" }} onClick={() => parentProps.handleGrilleSelection(module, module.grilles[0])} rel="noopener noreferrer" className="cdmButtonLink"><i className="fas fa-language"></i> {module.grilles[0].codeModule} - {module.grilles[0].name}</button> <sup>{I18n.get("Langue différente")}</sup></li>;
        }
        return (<li>{I18n.get("Grille non disponible")}</li>);
    };

    if (parentProps.modules) {

        parentProps.modules.sort((a, b) => {
            const codeA = a.grilles && a.grilles.length > 0 ? a.grilles[0].codeModule : '';
            const codeB = b.grilles && b.grilles.length > 0 ? b.grilles[0].codeModule : '';
            return (codeA > codeB) ? 1 : ((codeB > codeA) ? -1 : 0);
        });

        return (
            <div className="col-12 sm:col-12 md:col-12 lg:col-3">
                <div className="card">
                    <div className="p-card-title">{parentProps.modules[0].apprenti}</div>
                    <div className="p-card-subtitle">{parentProps.modules[0].metier}</div>
                    <div className="p-card-subtitle">{parentProps.modules[0].diplome}</div>
                    <div><ul className="cdm-clear-list">
                        {parentProps.modules.map((module, idxMod) => {
                            return (
                                <React.Fragment key={`appMod${idxMod}`}>
                                    {getGrille(module)}
                                </React.Fragment>
                            );
                        })
                        }
                    </ul>
                    </div>
                </div>
            </div>

        );
    }
    return <></>;
}